<template>
  <Base icon="mdi-progress-clock" :satisfied="requirement.satisfied" tooltip>
    <span>
      {{ new Date(requirement.value) | date('d MMM yyy') }}
    </span>
    <span slot="tooltip">
      {{ first ? 'The ideal candidate' : 'and' }}
      {{ requirement.mandatory ? 'must' : 'could' }} complete their qualification
      {{ requirement.negative ? 'after' : 'on or before' }}
      {{ new Date(requirement.value) | date('d MMMM yyy') }}
    </span>
  </Base>
</template>

<script>
// Component
import Base from '@/components/guest/opportunities/requirements/Base'

// Vue Component
export default {
  components: { Base },
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
  },
  computed: {
    description() {
      return this.$date(new Date(this.requirement.value), 'd MMMM yyy')
    },
  },
}
</script>
